export default __webpack_public_path__ + "static/media/bv.a0dbef9d.svg";